import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, AlertController, IonInput } from '@ionic/angular';
import { CartService } from '../../services/cart.service';
import { Decimal } from 'decimal.js';

@Component({
    selector: 'app-checkout-payment-cash',
    templateUrl: './checkout-payment-cash.page.html',
    styleUrls: ['./checkout-payment-cash.page.scss'],
})
export class CheckoutPaymentCashPage implements OnInit {

    @ViewChild('amount_tendered_input', { static: false }) amount_tendered_input: IonInput;

    payment = {
        method: 'cash',
        price: null,
        label: 'Cash'
    };

    cart = null;
    payment_amount = null
    change = 0;

    amount_due_rounded = null;
    cash_rounding_direction = null;
    cash_rounding_mode = '';
    cash_rounding_price = 0;
    cash_rounding_difference = 0;

    // cash rounding modes
    // 1 = 5 cents down
    // 2 = 5 cents nearest
    // 3 = 5 cents up
    // 4 = 10 cents halfway down
    // 5 = 10 cents halfway up

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService,
    ) { }

    ngOnInit() {
        this.cartService.get().then((cart) => {
            if(cart) {
                this.cart = cart;
                if(cart['currency'].cash_rounding_mode) {
                    this.cash_rounding_mode = cart['currency'].cash_rounding_mode;
                }
                this.calculateCashRounding();
            }
        });
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.amount_tendered_input) {
                this.amount_tendered_input.setFocus();
            }
        }, 200);
    }


    calculateCashRounding() {

        this.cash_rounding_price = 0;
        this.cash_rounding_difference = 0;

        let amount_due_last_digit = Number(new Decimal(this.cart.amount_due).minus(new Decimal(this.cart.amount_due).floor()).toDecimalPlaces(2).toFixed(2).slice(-1));
        let amount_due_last_digit_decimal = amount_due_last_digit / 100;

        if(this.cash_rounding_mode == '1' || this.cash_rounding_mode == '2' || this.cash_rounding_mode == '3') {
           
            if(amount_due_last_digit_decimal != 0.00 && amount_due_last_digit_decimal != 0.05) {

                if(this.cash_rounding_mode == "1") {
                    this.cash_rounding_direction = "-";
                    if(amount_due_last_digit_decimal < 0.05) {
                        this.cash_rounding_difference = amount_due_last_digit_decimal;
                    }
                    else if(amount_due_last_digit_decimal > 0.05) {
                        this.cash_rounding_difference = Number(new Decimal(amount_due_last_digit_decimal).minus(new Decimal(0.05)).toDecimalPlaces(2));
                    }
                }
                else if(this.cash_rounding_mode == "2") {
                    if(amount_due_last_digit_decimal == 0.01 || amount_due_last_digit_decimal == 0.02) {
                        this.cash_rounding_direction = "-";
                        this.cash_rounding_difference = amount_due_last_digit_decimal;
                    }
                    else if(amount_due_last_digit_decimal == 0.03 || amount_due_last_digit_decimal == 0.04) {
                        this.cash_rounding_direction = "+";
                        this.cash_rounding_difference = Number(new Decimal(0.05).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                    }
                    else if(amount_due_last_digit_decimal == 0.06 || amount_due_last_digit_decimal == 0.07) {
                        this.cash_rounding_direction = "-";
                        this.cash_rounding_difference =  Number(new Decimal(amount_due_last_digit_decimal).minus(new Decimal(0.05)).toDecimalPlaces(2));
                    }
                    else if(amount_due_last_digit_decimal == 0.08 || amount_due_last_digit_decimal == 0.09) {
                        this.cash_rounding_direction = "+";
                        this.cash_rounding_difference = Number(new Decimal(0.10).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                    }
                }
                else if(this.cash_rounding_mode == "3") {
                    this.cash_rounding_direction = "+";
                    if(amount_due_last_digit_decimal < 0.05) {
                        this.cash_rounding_difference = Number(new Decimal(0.05).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                    }
                    else if(amount_due_last_digit_decimal > 0.05) {
                        this.cash_rounding_difference = Number(new Decimal(0.10).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                    }
                }

            }
        }
        else if(this.cash_rounding_mode == '4' || this.cash_rounding_mode == '5') {
            
            if (amount_due_last_digit_decimal != 0.00) {
                if(amount_due_last_digit_decimal <= 0.04) {
                    this.cash_rounding_direction = "-";
                    this.cash_rounding_difference = amount_due_last_digit_decimal;
                }
                else if(amount_due_last_digit_decimal == 0.05) {
                    this.cash_rounding_difference = 0.05;
                    if(this.cash_rounding_mode == "4") {
                        this.cash_rounding_direction = "-";
                    }
                    else if(this.cash_rounding_mode == "5") {
                        this.cash_rounding_direction = "+";
                    }
                }
                else if(amount_due_last_digit_decimal >= 0.06) {
                    this.cash_rounding_direction = "+";
                    this.cash_rounding_difference = Number(new Decimal(0.10).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                }
            }
        }

        this.cash_rounding_price = this.cash_rounding_difference;

        // ensure negative values are passed correctly
        if(this.cash_rounding_direction == '-') {
            this.cash_rounding_price = Number(new Decimal(this.cash_rounding_difference).times(-1).toDecimalPlaces(2));
        }

        this.amount_due_rounded = Number(new Decimal(this.cart.amount_due).plus(new Decimal(this.cash_rounding_price)).toDecimalPlaces(2));

    }    

    sanitisePaymentAmount() {

        let payment_amount = this.payment_amount.toString();
        
        // only accept numbers/decimal points
        if(/[^0-9.]/.test(payment_amount)) {
            this.payment.price = null;
        }        
        else if(payment_amount.startsWith('.')) {
            this.payment.price = null;
        }
        else if(payment_amount.endsWith('.')) {
            this.payment.price = null;
        }              
        else if(payment_amount.split('.').length > 2) {
            this.payment.price = null;
        }
        else if(!payment_amount.length) {
            this.payment.price = null;
        }
        else {
            this.payment.price = Number(new Decimal(payment_amount).toDecimalPlaces(2));
        }

        this.calculateChange();

    }

    addPredefinedAmount(amount) {
        if(this.payment.price == null) {
            this.payment.price = 0;
        }
        this.payment.price = Number(new Decimal(this.payment.price).plus(new Decimal(amount)).toDecimalPlaces(2));
        this.payment_amount = this.payment.price;
        this.calculateChange();
    }

    calculateChange() {

        if(this.payment.price) {

            this.change = Number(new Decimal(this.payment.price).minus(new Decimal(this.amount_due_rounded)).toDecimalPlaces(2));

            if(this.change < 0) {
                this.change = 0;
            }
        }
        else {
            this.change = 0;
        }
    }

    addPayment() {

        // ensure payment isn't over the amount due
        if(this.payment.price > this.amount_due_rounded) {
            this.payment.price = this.amount_due_rounded;
        }

        this.cartService.addPayment(this.payment).then(() => {
            if(this.payment.price == this.amount_due_rounded) {
                this.cartService.updateCashRoundingPrice(this.cash_rounding_price).then(() => {
                    this.modalController.dismiss();
                });
            }
            else {
                this.modalController.dismiss();
            }
        });
    }

    close() {
        this.modalController.dismiss();
    }

}
